type Config = {
  API_KEY: string | null
  // when the API_KEY_HEADER_NAME is set, the API key will be sent as a header instead of a query parameter
  API_KEY_HEADER_NAME: string | null
  API_HOST: string | null
  DISABLE_NB_TRANSFORM: boolean
}

const config: Config = {
  API_KEY: null,
  API_KEY_HEADER_NAME: null,
  API_HOST: 'api.nextbillion.io',
  DISABLE_NB_TRANSFORM: false,
}

export default config
